import React from "react";
import Card from "components/card";
import { Form, Input } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import TextArea from "antd/es/input/TextArea";
import SelectOption from "components/select/SelectOption";
import Button from "components/button";
import { 
    CircleQuestionMark,
    DollarSign,
    GraduationCap,
    Headphones,
    Heart,
    Send,
    Users,
    Settings,
} from "lucide-react";

const MessageTicket = ({
    onClose,
}) => {
    const [form] = Form.useForm();

    const onSubmit = (formData) => {};

    const departmentOptions = [
        { label: "Human Resources", value: 0, icon: <Users className="w-4 h-4" /> },
        { label: "Payroll Services", value: 1, icon: <DollarSign className="w-4 h-4" /> },
        { label: "IT Support", value: 2, icon: <Headphones className="w-4 h-4" /> },
        { label: "Training Development", value: 3, icon: <GraduationCap className="w-4 h-4" /> },
        { label: "People & Culture", value: 4, icon: <Heart className="w-4 h-4" /> },
        { label: "Operations", value: 5, icon: <Settings className="w-4 h-4" /> },
        { label: "General Inquiries", value: 6, icon: <CircleQuestionMark className="w-4 h-4" /> },
    ];

    return (
        <Card className="grid w-full gap-4 border rounded-lg shadow-lg p-6">
            <div className="flex flex-col gap-2 text-center sm:text-left">
                <h2 className="text-lg leading-none font-semibold">
                    Contact Hyvid Department
                </h2>
                <p className="text-slate-700 text-sm">
                    Send a message to any Hyvid department for support and assistance
                </p>
            </div>
            <Form
                form={form}
                layout="vertical" 
                onFinish={onSubmit}
            >
                <div className="space-y-4 py-4">
                    <div className="space-y-2">
                        <FormItem
                            label="Department"
                            rules={[requiredField()]}
                        >
                            <SelectOption
                                placeholder="Select department"
                                options={departmentOptions}
                                showLabel={true}
                            />
                        </FormItem>
                        <FormItem
                            label="Priority"
                            rules={[requiredField()]}
                        >
                            <SelectOption
                                placeholder="Select priority"
                                options={[
                                    {label:"Low - General inquiry", value: 0},
                                    {label:"Medium - Standard request", value: 1},
                                    {label:"High - Urgent issue", value: 2},
                                ]}
                            />
                        </FormItem>
                        <FormItem
                            label="Subject"
                            rules={[requiredField()]}
                        >
                            <Input
                                className="input-field"
                                placeholder="Brief description of your inquiry"
                            />
                        </FormItem>
                        <FormItem
                            label="Description"
                            rules={[requiredField()]}
                        >
                            <TextArea
                                id=""
                                className="input-field"
                                maxLength={255}
                                placeholder="Provide details about your question or issue..."
                            />
                        </FormItem>
                    </div>
                    <div className="flex gap-2 justify-end">
                        <Button
                            onClick={() => onClose?.()}
                            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-medium
                                        transition-all shrink-0 bg-white text-slate-900 
                                        hover:bg-slate-100 hover:shadow-none hover:text-slate-900  h-9 px-4 py-2 border-2"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={onSubmit}
                            className="inline-flex items-center justify-center gap-2 rounded-xl 
                                        text-sm font-medium transition-all outline-none hover:bg-emerald-500/90 h-9 px-4 py-2 
                                        bg-gradient-to-r from-emerald-600 to-green-600 hover:shadow-none
                                        hover:from-emerald-700 hover:to-green-700 text-white"
                        >
                            <Send className="w-4 h-4 mr-2"/>
                            Send Message
                        </Button>
                    </div>
                </div>
            </Form>
        </Card>
    )
};
export default MessageTicket;